<template>
  <v-list-group
    :group="group"
    :prepend-icon="item.icon"
    :sub-group="subGroup"
    no-action
  >
    <template v-slot:activator>
      <v-list-item-content class="v-list-group__activator">
        <v-list-item-title>
          {{ item.text }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-for="(child, i) in item.children">
      <navbar-sub-group
        v-if="child.group != null"
        :key="`sub-group-${i}`"
        :item="child"
      />
      <navbar-item
        v-else
        :key="`item-${i}`"
        :icon="child.icon"
        :to="child.to"
        :text="child.text"
      />
    </template>
  </v-list-group>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      default: () => ({
        text: '',
        group: '',
        children: [],
      }),
    },
    subGroup: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    group() {
      return this.genGroup(this.item.children);
    },
  },

  methods: {
    genGroup(children) {
      const grouping = children
        .map(item => {
          const parent = item.group || this.item.group;
          let group = `${parent}/${item.to.name}`;
          if (item.children) {
            group = `${group}|${this.genGroup(item.children)}`;
          }
          return group;
        })
        .join('|');
      return grouping;
    },
  },
};
</script>

<style scoped>
>>> .v-list-group__activator p {
  margin-bottom: 0;
}
</style>
